import * as React from 'react';
import {useHistory} from 'react-router';
import {BaseScreen} from '../../../components/screens/BaseScreen';
import {SvgImage} from '../../../components/SvgImage/SvgImage';
import {CenteredWrapper} from '../../../components/screens/layout';
import {ResendEmail} from '../layout';
import {routes} from '../routes';
import {forgotPassword} from '../../../http/login';

export const PasswordEmailSent: React.FC = () => {
  const history = useHistory<{username_or_email: string}>();
  const {username_or_email} = history.location.state;
  return (
    <BaseScreen
      helmetTitle="Reset Email Sent"
      headerTitle="Forgot Password"
      title="Email Sent!"
      instructions={
        <>
          We have sent an email to <strong>{username_or_email}</strong> with
          further instructions.
        </>
      }
      actionButtons={[
        {onClick: () => history.push(routes.login.index), children: 'Login'},
      ]}
      bottomText={
        <ResendEmail resend={() => forgotPassword({username_or_email})} />
      }
    >
      <CenteredWrapper>
        <SvgImage name="mailbox" />
      </CenteredWrapper>
    </BaseScreen>
  );
};
